import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {GitCommit, HardDrive, Share} from "react-feather";

const STEP_TIME = 2500;

export function CertificateAnimation({show, loading, withFiles, callback}: { show: boolean, loading: boolean, withFiles: boolean, callback: any }) {
    const {t} = useTranslation();
    const [delay, setDelay] = useState<any>();
    const [open, setOpen] = useState(false);
    const [step, setStep] = useState(0);
    const [startTime, setStartTime] = useState(0);
    useEffect(() => {
        clearTimeout(delay);
        if (show) {
            setStartTime(new Date().getTime());
            setDelay(setTimeout(() => {
                setOpen(true);
                setStep(0);
                setDelay(setTimeout(() => {
                    setStep(1);
                }, 300));
            }, 0));
        } else {
            setOpen(false);
        }
        return () => clearTimeout(delay);
    }, [show]);
    useEffect(() => {
        if (!loading && open && step > 0) {
            clearTimeout(delay);
            let timeout = STEP_TIME;
            if (step === 1) {
                const time = new Date().getTime() - startTime;
                if (time > timeout) {
                    timeout = 0;
                } else {
                    timeout -= time;
                }
            }
            setDelay(setTimeout(() => {
                if (step < 3) {
                    if(step === 1 && !withFiles) {
                        setStep(3);
                    } else {
                        setStep(step + 1);
                    }
                } else {
                    setOpen(false);
                    callback();
                }
            }, timeout));
        }
        return () => clearTimeout(delay);
    }, [loading, open, step]);

    if (!show) {
        return null;
    }

    return (
        <div className={'certificate-animation' + (open ? ' open' : '')}>
            <div className={'step' + (step < 1 ? ' before' : '') + (step > 1 ? ' after' : '')}>
                <div className={'circle'}>
                    <div className={'half1'}/>
                    <div className={'half2'}/>
                    <Share width={96} height={96} className={'text-secondary'} style={{margin: '2rem'}}/>
                </div>
                <div className={'title'}>{t('certificate.step1')}</div>
            </div>
            <div className={'step' + (step < 2 ? ' before' : '') + (step > 2 ? ' after' : '')}>
                <div className={'circle'}>
                    <div className={'half1'}/>
                    <div className={'half2'}/>
                    <HardDrive width={96} height={96} className={'text-secondary'} style={{margin: '2rem'}}/>
                </div>
                <div className={'title'}>{t('certificate.step2')}</div>
            </div>
            <div className={'step' + (step < 3 ? ' before' : '') + (step > 3 ? ' after' : '')}>
                <div className={'circle'}>
                    <div className={'half1'}/>
                    <div className={'half2'}/>
                    <GitCommit width={96} height={96} className={'text-secondary'} style={{margin: '2rem'}}/>
                </div>
                <div className={'title'}>{t('certificate.step3')}</div>
            </div>
        </div>
    );
}
